export default {
  standings: {
    title: "Posiciones",
    empty: {
      unavailable: "Las posiciones no están disponibles en este momento.",
    },
    labels: {
      ranking: "#",
      team: "Equipo",
    },
    columns: {
      GP: "PJ",
      W: "V",
      L: "D",
      T: "E",
      OTL: "DPP",
      PTS: "PTS",
      PCT: "PCT",
      D: "E",
    },
    picker: {
      conference: "Conferencia",
      division: "División",
      overall: "General",
    },
    sections: {
      conference: "Conferencia",
      division: "División",
      overall: "General",
    },
  },
};